import { mdiDelete } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { useDeletePostbackMutation } from 'modules/PostbacksModule/api/postbacks.api';
import { snackbar } from 'components/notifications/notifications';
import { Button } from 'antd';
import Ninja from '@ninja';
import Confirmation from 'components/Dialogs/Confirmation';

const DeleteReceivedPostback = ({ id }) => {
  const [deletePostback, { isLoading }] = useDeletePostbackMutation();

  const handleDeletePostback = () => {
    deletePostback({ id: row.id })
      .unwrap()
      .then(() => snackbar.success(`${row.name} postback successfully deleted`));
  };

  return (
    <Confirmation
      description='Are you sure to delete this postback?'
      onConfirm={handleDeletePostback}
      okText='Yes'
      cancelText='No'
    >
      <Button
        onClick={(e) => e.stopPropagation()}
        disabled={isLoading}
        loading={isLoading}
        icon={<Icon path={mdiDelete} color={Ninja.colors.light} />}
        type='text'
      />
    </Confirmation>
  );
};

export default DeleteReceivedPostback;
